import {ChangeDetectionStrategy, Component, Injectable, input, Signal} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable, switchMap} from "rxjs";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {DokumentId, DokumentRessursClient, DokumentVersjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {DokumentKortvisningKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-kortvisning/dokument-kortvisning";
import {DelegerteDokumentMenyOperasjoner, DelegerteDokumentMenyOperasjoner_DI_TOKEN} from "web-ng2/moduler/dokument/komponenter/dokument-meny/dokument-meny";
import {DelegerteDokumentvisningOperasjoner, DelegerteDokumentvisningOperasjoner_DI_TOKEN} from "web-ng2/moduler/dokument/komponenter/dokumentvisning/DokumentvisningBasisKomponent";

const debug = initDebugger('DokumentversjonListeKomponent');

/**
 * Lister dokumentversjoner for angitt dokument
 */
@Component({
    selector: 'dokumentversjon-liste',
    templateUrl: 'dokumentversjon-liste.html',
    styleUrl: 'dokumentversjon-liste.scss',
    imports: [
        DokumentKortvisningKomponent
    ],
    providers: [
        //alternativt kunne {provide:.., useExisting:DokumentversjonListeKomponent} blitt brukt, men her er nedsiden at ArkivTrevisningKoDokumentversjonListeKomponentmponent da må impl alle Delegert... interfacene - med overlappende metodenavn...
        {provide: DelegerteDokumentMenyOperasjoner_DI_TOKEN, useFactory: (komponent: DokumentversjonListeKomponent) => komponent.delegerteDokumentMenyOperasjoner(), deps: [DokumentversjonListeKomponent]},
        {provide: DelegerteDokumentvisningOperasjoner_DI_TOKEN, useFactory: (komponent: DokumentversjonListeKomponent) => komponent.delegerteDokumentvisningOperasjoner(), deps: [DokumentversjonListeKomponent]},
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentversjonListeKomponent {

    dokumentId = input.required<DokumentId>();
    dokumentBredde = input(DokumentKortvisningKomponent.standardBredde);
    dokumentHoeyde = input(DokumentKortvisningKomponent.standardHøyde);

    readonly versjoner: Signal<DokumentVersjonModell[]>;

    constructor(private avhengigheter: DokumentversjonListeKomponentAvhengigheter) {
        this.versjoner = toSignal(toObservable(this.dokumentId)
            .pipe(switchMap(id => this.avhengigheter.dokumentversjoner(id))), {initialValue: []});
    }

    /** DelegerteDokumentMenyOperasjoner implementasjon.
     * Merk at vi forutsetter at dokumentDetaljer vises når disse kallene skjer, ved klikk på dokument-meny vil klikket på menyen ha ført til at
     * this.visDetaljerFor(..) allerede har blitt kalt, og følgelig vises dokumentDetaljer */
    delegerteDokumentMenyOperasjoner(): DelegerteDokumentMenyOperasjoner {
        return {
            visAlleVersjoner: async dokumentversjon => {
            },

            visSignatarer: async dokumentversjon => {
            },

            visSakerArkivdokumentBehandlesI: async dokumentversjon => {
            },

            visSkjerming: dokumentversjon => {
            },

            registrerNyDokumentversjon: dokumentversjon => {
            },

            tilgjengeligFunksjonalitet: dokumentversjon => {
                return {
                    rediger: false,
                    // alle øvrige funksjoner skal alltid være aktive i arkiv @todo - mangler vi impl her?
                    behandlesISaker: false,
                    favorittmarkering: false,
                    signering: false,
                    versjonsvisning: false,
                    skjerming: false
                };
            }
        };
    }

    delegerteDokumentvisningOperasjoner(): DelegerteDokumentvisningOperasjoner {
        return {
            visSkjerming: dokumentversjon => {},
            visSignatarer: dokumentversjon => {}
        };
    }

}

@Injectable()
export class DokumentversjonListeKomponentAvhengigheter {

    constructor(private dokumentRessursClient: DokumentRessursClient) {
    }

    dokumentversjoner(dokumentId: DokumentId): Observable<DokumentVersjonModell[]> {
        return this.dokumentRessursClient.hentVersjoner(dokumentId).somObservable();
    }

}
